//Pipeline reducer constants
const PIPELINE_SET_LOADING = "SET_LOADING";
const PIPELINE_SET_PIPELINE = "SET_PIPELINE";
const PIPELINE_MOVE_TASK = "MOVE_TASK";
const PIPELINE_REORDER_TASK = "REORDER_TASK";
const PIPELINE_ADD_TASK = "ADD_TASK";
const PIPELINE_ADD_STAGE = "ADD_STAGE";
const PIPELINE_DELETE_STAGE = "DELETE_STAGE";
const PIPELINE_SET_EXISTING_PIPELINES = "SET_EXISTING_PIPELINES";
const PIPELINE_ADD_EXISTING_PIPELINE = "ADD_EXISTING_PIPELINE";
const PIPELINE_EDIT_TASK = "EDIT_TASK";
const PIPELINE_EDIT_STAGE = "EDIT_STAGE";
const PIPELINE_MOVE_STAGE = "MOVE_STAGE";
const PIPELINE_ADD_PIPELINE = "ADD_PIPELINE";
const PIPELINE_EDIT_PIPELINE = "EDIT_PIPELINE";
const PIPELINE_SET_PRIMARY = "SET_PRIMARY";
const PIPELINES_SET = "SET_PIPELINES";
const PIPELINE_SET_PRIMARY2 = "SET_PRIMARY";
const PIPELINE_ADD_USER_TO_TASK = "ADD_USER_TO_TASK";
const PIPELINE_REMOVE_USER_FROM_TASK = "REMOVE_USER_FROM_TASK";
const PIPELINE_CHANGE_TASK_DONE_STATUS = "CHANGE_TASK_DONE_STATUS";
const PIPELINE_REMOVE_PIPELINE = "REMOVE_PIPELINE";
const PIPELINE_REMOVE_ACTIVE_PIPELINE = "REMOVE_ACTIVE_PIPELINE";
//Modal reducer constants
const OPEN_NEW_TASK_MODAL = "OPEN_NEW_TASK_MODAL";
const CLOSE_NEW_TASK_MODAL = "CLOSE_NEW_TASK_MODAL";
const OPEN_EDIT_TASK_MODAL = "OPEN_EDIT_TASK_MODAL";
const CLOSE_EDIT_TASK_MODAL = "CLOSE_EDIT_TASK_MODAL";
const CLOSE_TASK_MODAL = "CLOSE_TASK_MODAL";
const OPEN_NEW_STAGE_MODAL = "OPEN_NEW_STAGE_MODAL";
const CLOSE_STAGE_MODAL = "CLOSE_STAGE_MODAL";
const OPEN_STAGE_EDIT_MODAL = "OPEN_STAGE_EDIT_MODAL";
const OPEN_NEW_PIPELINE_MODAL = "OPEN_NEW_PIPELINE_MODAL";
const OPEN_EDIT_PIPELINE_MODAL = "OPEN_EDIT_PIPELINE_MODAL";
const CLOSE_PIPELINE_MODAL = "CLOSE_PIPELINE_EDIT_MODAL";
const CLOSE_USER_MODAL = "CLOSE_USER_MODAL";
const OPEN_NEW_USER_MODAL = "OPEN_NEW_USER_MODAL";
const OPEN_EDIT_USER_MODAL = "OPEN_EDIT_USER_MODAL";
const ADD_ASSIGNED_USER_TO_EDITING_TASK = "ADD_ASSIGNED_USER_TO_EDITING_TASK";
const REMOVE_ASSIGNED_USER_FROM_EDITING_TASK = "REMOVE_ASSIGNED_USER_FROM_EDITING_TASK";
const CHANGE_USER_SETTINGS_MODAL_OPEN = "CHANGE_USER_SETTINGS_MODAL_OPEN";
const CHANGE_TASK_DONE_STATUS = "CHANGE_TASK_DONE_STATUS";
//Archive reducer constants
const SET_ARCHIVE_TASKS = "SET_ARCHIVE_TASKS";
const OPEN_ARCHIVE_TASK_MODAL = "OPEN_ARCHIVE_TASK_MODAL";
const CLOSE_ARCHIVE_TASK_MODAL = "CLOSE_ARCHIVE_TASK_MODAL";
const SET_ARCHIVE_SEARCH_VALUE = "SET_ARCHIVE_SEARCH_VALUE";
const SET_ARCHIVE_FILTERED_PIPELINE = "SET_ARCHIVE_FILTERED_PIPELINE";
const REMOVE_ARCHIVED_TASK = "REMOVE_ARCHIVED_TASK";
const ADD_ASSIGNED_USER_TO_ARCHIVED_TASK = "ADD_ASSIGNED_USER_TO_ARCHIVED_TASK";
const REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK = "REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK";
const CHANGE_ARCHIVED_TASK_DONE_STATUS = "CHANGE_ARCHIVED_TASK_DONE_STATUS";
const EDIT_ARCHIVED_TASK = "EDIT_ARCHIVED_TASK";
const CHANGE_ARCHIVE_TASK_DONE_FILTER = "CHANGE_ARCHIVE_TASK_DONE_FILTER";
//User reducer constants
const SET_USERS = "SET_USERS";
const ADD_USER = "ADD_USER";
const SET_USERS_SEARCH_VALUE = "SET_USERS_SEARCH_VALUE";
const EDIT_USER = "EDIT_USER";
const DELETE_USER = "DELETE_USER";
const CHANGE_USER_STATUS = "CHANGE_USER_STATUS";
const RESET_PASSWORD = "RESET_PASSWORD";
//App reducer
const SET_SITE_URL = "SET_SITE_URL";
const INIT_APP_STATE = "INIT_APP_STATE";
//Loading reducer
const SET_FULL_PAGE_LOADING = "SET_FULL_PAGE_LOADING";
//User sessions reducer
const SET_USER_SESSIONS_SEARCH_VALUE = "SET_USER_SESSIONS_SEARCH_VALUE";
const SET_USER_SESSIONS = "SET_USER_SESSIONS";
const CHANGE_USER_SESSION_STATUS = "CHANGE_USER_SESSION_STATUS";
const DELETE_USER_SESSION = "DELETE_USER_SESSION";
//User tasks reducer
const SET_USER_TASKS = "SET_USER_TASKS";
const SET_USER_TASKS_SEARCH_VALUE = "SET_USER_TASKS_SEARCH_VALUE";
const REMOVE_USER_TASK = "REMOVE_USER_TASK";
const EDIT_USER_TASK = "EDIT_USER_TASK";
const SET_USER_TASKS_FILTERED_PIPELINE = "SET_USER_TASKS_FILTERED_PIPELINE";
const ADD_ASSIGNED_USER_TO_USER_TASK = "ADD_ASSIGNED_USER_TO_USER_TASK";
const REMOVE_ASSIGNED_USER_FROM_USER_TASK = "REMOVE_ASSIGNED_USER_FROM_USER_TASK";
const CHANGE_USER_TASK_DONE_STATUS = "CHANGE_USER_TASK_DONE_STATUS";
//Custom Fields reducer
const SET_CUSTOM_FIELDS = "SET_CUSTOM_FIELDS";
const ADD_CUSTOM_FIELD = "ADD_CUSTOM_FIELD";
const EDIT_CUSTOM_FIELD = "EDIT_CUSTOM_FIELD";
const DELETE_CUSTOM_FIELD = "DELETE_CUSTOM_FIELD";
const SET_CUSTOM_FIELD_LOADING = "SET_CUSTOM_FIELD_LOADING";
const SET_CUSTOM_FIELDS_LOCATION = "SET_CUSTOM_FIELDS_LOCATION";
const SET_CUSTOM_FIELD_INITIAL_DATA = "SET_CUSTOM_FIELD_INITIAL_DATA";
//Timers
const REFETCH_ACTIVE_PIPELINE_INTERVAL = 30000;
//Misc
const WP_QUICKTASKER_INVALID_SESSION_TOKEN = "Invalid session token";
export { ADD_ASSIGNED_USER_TO_ARCHIVED_TASK, ADD_ASSIGNED_USER_TO_EDITING_TASK, ADD_ASSIGNED_USER_TO_USER_TASK, ADD_CUSTOM_FIELD, ADD_USER, CHANGE_ARCHIVED_TASK_DONE_STATUS, CHANGE_ARCHIVE_TASK_DONE_FILTER, CHANGE_TASK_DONE_STATUS, CHANGE_USER_SESSION_STATUS, CHANGE_USER_SETTINGS_MODAL_OPEN, CHANGE_USER_STATUS, CHANGE_USER_TASK_DONE_STATUS, CLOSE_ARCHIVE_TASK_MODAL, CLOSE_EDIT_TASK_MODAL, CLOSE_NEW_TASK_MODAL, CLOSE_PIPELINE_MODAL, CLOSE_STAGE_MODAL, CLOSE_TASK_MODAL, CLOSE_USER_MODAL, DELETE_CUSTOM_FIELD, DELETE_USER, DELETE_USER_SESSION, EDIT_ARCHIVED_TASK, EDIT_CUSTOM_FIELD, EDIT_USER, EDIT_USER_TASK, INIT_APP_STATE, OPEN_ARCHIVE_TASK_MODAL, OPEN_EDIT_PIPELINE_MODAL, OPEN_EDIT_TASK_MODAL, OPEN_EDIT_USER_MODAL, OPEN_NEW_PIPELINE_MODAL, OPEN_NEW_STAGE_MODAL, OPEN_NEW_TASK_MODAL, OPEN_NEW_USER_MODAL, OPEN_STAGE_EDIT_MODAL, PIPELINES_SET, PIPELINE_ADD_EXISTING_PIPELINE, PIPELINE_ADD_PIPELINE, PIPELINE_ADD_STAGE, PIPELINE_ADD_TASK, PIPELINE_ADD_USER_TO_TASK, PIPELINE_CHANGE_TASK_DONE_STATUS, PIPELINE_DELETE_STAGE, PIPELINE_EDIT_PIPELINE, PIPELINE_EDIT_STAGE, PIPELINE_EDIT_TASK, PIPELINE_MOVE_STAGE, PIPELINE_MOVE_TASK, PIPELINE_REMOVE_ACTIVE_PIPELINE, PIPELINE_REMOVE_PIPELINE, PIPELINE_REMOVE_USER_FROM_TASK, PIPELINE_REORDER_TASK, PIPELINE_SET_EXISTING_PIPELINES, PIPELINE_SET_LOADING, PIPELINE_SET_PIPELINE, PIPELINE_SET_PRIMARY, PIPELINE_SET_PRIMARY2, REFETCH_ACTIVE_PIPELINE_INTERVAL, REMOVE_ARCHIVED_TASK, REMOVE_ASSIGNED_USER_FROM_EDITING_TASK, REMOVE_ASSIGNED_USER_FROM_USER_TASK, REMOVE_ASSINGED_USER_FROM_ARCHIVED_TASK, REMOVE_USER_TASK, RESET_PASSWORD, SET_ARCHIVE_FILTERED_PIPELINE, SET_ARCHIVE_SEARCH_VALUE, SET_ARCHIVE_TASKS, SET_CUSTOM_FIELDS, SET_CUSTOM_FIELDS_LOCATION, SET_CUSTOM_FIELD_INITIAL_DATA, SET_CUSTOM_FIELD_LOADING, SET_FULL_PAGE_LOADING, SET_SITE_URL, SET_USERS, SET_USERS_SEARCH_VALUE, SET_USER_SESSIONS, SET_USER_SESSIONS_SEARCH_VALUE, SET_USER_TASKS, SET_USER_TASKS_FILTERED_PIPELINE, SET_USER_TASKS_SEARCH_VALUE, WP_QUICKTASKER_INVALID_SESSION_TOKEN, };
